import { render, staticRenderFns } from "./cases.vue?vue&type=template&id=79cd650a&scoped=true&"
import script from "./cases.vue?vue&type=script&lang=js&"
export * from "./cases.vue?vue&type=script&lang=js&"
import style0 from "./cases.vue?vue&type=style&index=0&id=79cd650a&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79cd650a",
  null
  
)

export default component.exports